import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Box from "@mui/material/Box";
import { modifyUser, addUser } from "../../domain/apis/userService";
import _ from "lodash";
import { useEffect, useState } from "react";
import { FormUIItem } from "../commons";
import { ComboBox } from "../commons/Combobox";
import Row from "react-bootstrap/Row";
import FormControl from "@mui/material/FormControl";
import Col from "react-bootstrap/Col";
import { styles } from "./styles";
import DatePicker from "react-datepicker";

function UserModifyComponent({ show, handleClose, data }) {
  const [formUI, setFormUI] = useState({});
  const [error, setError] = useState({});
  const [dateOfBirth, setDateOfBirth] = useState();

  useEffect(() => {
    setError({});
  }, [show]);

  useEffect(() => {
    if (!data) {
      setFormUI({});
      setDateOfBirth(null);
    } else {
      setFormUI(data);
      setDateOfBirth(data.dateOfBirth ? new Date(data.dateOfBirth) : null);
    }
  }, [data, show]);

  const handleUpdateForm = (key, value) => {
    let obj = {};
    obj[key] = value;
    setFormUI({
      ...formUI,
      ...obj,
    });
  };

  const validateForm = () => {
    var result = true;
    var errorState = {};

    if (!formUI["username"] || formUI["username"] === "") {
      result = false;
      errorState.username = true;
    }

    if (!formUI["password"] || formUI["password"] === "") {
      result = false;
      errorState.password = true;
    }

    if (!formUI["email"] || formUI["email"] === "") {
      result = false;
      errorState.email = true;
    }

    if (!formUI["phone"] || formUI["phone"] === "") {
      result = false;
      errorState.phone = true;
    }

    if (!formUI["fullName"] || formUI["fullName"] === "") {
      result = false;
      errorState.fullName = true;
    }

    if (!formUI["role"] || formUI["role"] === "") {
      result = false;
      errorState.role = true;
    }

    setError(errorState);
    return result;
  };

  const onModify = () => {
    if (!validateForm()) {
      return;
    }

    if (data) {
      modifyUser(formUI).subscribe({
        next: ({ data }) => {
          handleClose(true);
        },
      });
      return;
    }
    addUser(formUI).subscribe({
      next: ({ data }) => {
        handleClose(true);
      },
    });
  };

  return (
    <>
      <Modal
        show={show}
        onHide={() => handleClose()}
        centered
        style={{ zIndex: 10000 }}
      >
        <Modal.Header>
          <div
            style={{ display: "flex", justifyContent: "center", width: "100%" }}
          >
            {data && <Modal.Title>Chỉnh sửa người dùng</Modal.Title>}
            {!data && <Modal.Title>Thêm người dùng</Modal.Title>}
          </div>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <FormControl fullWidth sx={{ m: 1 }}>
              <Row style={{ marginRight: -4 }}>
                <Col
                  className="col-6 col-md-4"
                  style={{ ...styles.selfCenter, ...styles.textNormal }}
                >
                  Loại *
                </Col>
                <Col className="col-12 col-sm-6 col-md-8">
                  <ComboBox
                    value={formUI["role"]}
                    error={_.get(error, "role")}
                    errorMessage={"Vui lòng chọn nội dung!"}
                    data={[
                      { id: "admin", name: "Admin" },
                      { id: "editor", name: "Biên tập" },
                    ]}
                    placeHolder={"--- Chọn loại người dùng ---"}
                    onItemChange={(value) => {
                      handleUpdateForm("role", value);
                    }}
                  />
                </Col>
              </Row>
            </FormControl>
            <Box sx={{ display: "flex", flexWrap: "wrap" }}>
              <FormUIItem
                label={"Tên người dùng"}
                code={"username"}
                required
                error={_.get(error, "username")}
                errorMessage={"Vui lòng nhập nội dung!"}
                initValue={_.get(data, "username")}
                handleUpdate={handleUpdateForm}
              />
              <FormUIItem
                label={"Mật khẩu"}
                code={"password"}
                required
                error={_.get(error, "password")}
                errorMessage={"Vui lòng nhập nội dung!"}
                initValue={_.get(data, "password")}
                handleUpdate={handleUpdateForm}
              />
              <FormUIItem
                label={"Họ tên"}
                code={"fullName"}
                required
                error={_.get(error, "fullName")}
                errorMessage={"Vui lòng nhập nội dung!"}
                initValue={_.get(data, "fullName")}
                handleUpdate={handleUpdateForm}
              />
              <FormUIItem
                label={"Email"}
                error={_.get(error, "email")}
                required
                errorMessage={"Vui lòng nhập nội dung!"}
                code={"email"}
                initValue={_.get(data, "email")}
                handleUpdate={handleUpdateForm}
              />
              <FormUIItem
                label={"Điện thoại"}
                error={_.get(error, "phone")}
                required
                errorMessage={"Vui lòng nhập nội dung!"}
                code={"phone"}
                initValue={_.get(data, "phone")}
                handleUpdate={handleUpdateForm}
              />
              <Row
                style={{
                  marginLeft: 2,
                  display: "inline-block",
                  marginBottom: 4,
                }}
              >
                <span
                  style={{
                    ...styles.selfCenter,
                    ...styles.textNormal,
                    marginLeft: -12,
                  }}
                >
                  Sinh ngày
                </span>
                <DatePicker
                  onChange={(date) => {
                    setDateOfBirth(date);
                    handleUpdateForm("dateOfBirth", date);
                  }}
                  dateFormat="dd/MM/yyyy"
                  selected={dateOfBirth}
                />
              </Row>
              <FormUIItem
                label={"Địa chỉ"}
                code={"address"}
                initValue={_.get(data, "address")}
                handleUpdate={handleUpdateForm}
              />
            </Box>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleClose()}>
            Hủy
          </Button>
          <Button variant="primary" onClick={() => onModify()}>
            Lưu
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default UserModifyComponent;
